var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnegMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_833_11134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.64 45.6L64.99 40.83L60.94 33.47C57.74 27.64 51.61 24.02 44.97 24.02H20.03C17.35 24.02 15.18 26.19 15.18 28.87V47.98H14.21C13.56 47.98 13.03 48.51 13.03 49.16V52.83C13.03 54.4 14.3 55.67 15.87 55.67H19.83C19.83 52.08 22.74 49.17 26.33 49.17C29.92 49.17 32.83 52.08 32.83 55.67H53.08C53.08 52.08 55.99 49.17 59.58 49.17C63.17 49.17 66.08 52.08 66.08 55.67H69.89C71.54 55.67 72.87 54.33 72.87 52.69V48.04C72.87 47.08 72.41 46.17 71.62 45.61L71.64 45.6Z",
    stroke: "#231F20",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.96 30.2C49.17 30.2 53.05 32.49 55.08 36.18L57.64 40.84H44.96V30.2Z",
    stroke: "#231F20",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5801 62.16C63.1699 62.16 66.0801 59.2499 66.0801 55.66C66.0801 52.0702 63.1699 49.16 59.5801 49.16C55.9902 49.16 53.0801 52.0702 53.0801 55.66C53.0801 59.2499 55.9902 62.16 59.5801 62.16Z",
    stroke: "#231F20",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3401 62.16C29.9299 62.16 32.8401 59.2499 32.8401 55.66C32.8401 52.0702 29.9299 49.16 26.3401 49.16C22.7502 49.16 19.8401 52.0702 19.8401 55.66C19.8401 59.2499 22.7502 62.16 26.3401 62.16Z",
    stroke: "#231F20",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_833_11134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.92,
    height: 42.19,
    fill: "white",
    transform: "translate(11 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnegMini);
export default __webpack_public_path__ + "static/media/knegMini.28d4fcc1bf9055e85c9e31ff611c13b0.svg";
export { ForwardRef as ReactComponent };